export const getWorkingHours = (hours, minutes) => {
    if(!hours) return (minutes/60).toFixed(2);
    else if(!minutes) return hours + ".00";
    else return (hours + minutes/60).toFixed(2);
}